const t = "restaurantInfo_KZWFe", n = "restaurantInfo__title_uXvJQ", a = {
  restaurantInfo: t,
  restaurantInfo__title: n
};
export {
  a as default,
  t as restaurantInfo,
  n as restaurantInfo__title
};
//# sourceMappingURL=restaurant.module.scss.js.map
